const baseUrl = '/payment/api/';
export const statementsRoutes = {
  accountStatementsPreview: 'statements/account-statements-preview',
  accountStatement: 'statements/accountstatement',
  baseUrl: "".concat(baseUrl),
  propertyStatements: 'statements/property-statements',
  sendPaperStatement: 'statements/send-paper-statement',
  statement: statementId => "statements/statement/".concat(statementId),
  voidStatement: 'statements/void-statement'
};